var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field-group',{attrs:{"inline":"","label":_vm.label,"typeInput":"v-select","items":_vm.fonts},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }